import { render, staticRenderFns } from "./IdentityStatsPage.vue?vue&type=template&id=85d8a472&"
import script from "./IdentityStatsPage.vue?vue&type=script&lang=js&"
export * from "./IdentityStatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports